<template>
  <div class="content-wrapper safe-top">
    <div class="form form-middle">
      <div class="form-content-middle">
        <div class="img-container">
          <img src="@/assets/img/dialog/svg/dialog_alert.svg" alt="" />
        </div>
        <div>
          <div class="msg">
            <p v-if="paymentResult?.result === 'success'">
              処理結果が取得できませんでした。しばらく経っても選択したチケットが一覧に表示されない場合は、大変お手数ですがもう一度購入手続きをやり直してください。
            </p>
            <p v-else>
              決済に失敗した可能性があります。選択したチケットが一覧に表示されない場合は、大変お手数ですがもう一度購入手続きをやり直してください。
            </p>
          </div>
          <div class="foot-button-block">
            <div class="actions">
              <ItemButton
                label="特急券を確認する"
                action-type="btn-primary"
                @clicked="backToPreviousPage()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittBookingTimeoutPage",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const paymentResult = store.getters["MFITT/paymentResult"];

    const backToPreviousPage = () => {
      if (process.env.NODE_ENV == "local") {
        router.push({
          name: "MfittIndex",
        });
      } else {
        nativeHandlerService.ncReturnNativeAppToMFITT();
      }
    };

    return {
      backToPreviousPage,
      paymentResult,
    };
  },
};
</script>
<style scoped lang="scss">
.safe-top {
  margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px);
}

.msg {
  padding: 0 20px;
  font-size: 15px;
  text-align: left;
}

.img-container {
  text-align: center;
  padding-top: 200px;
}

.img-container img {
  height: 90px;
  width: 90px;
}

.form-middle {
  position: absolute;
  width: 100%;
  height: 50%;
}

.form-content-middle {
  position: absolute;
  width: 100%;
  bottom: 45px;
}
.foot-button-block {
  position: fixed;
  z-index: 99;
  width: 100%;
  bottom: 0;
  background-color: #fff;
}

.foot-button-block .actions {
  width: 90%;
  margin: auto;
}
</style>
